import Link from 'next/link';
import styled from 'styled-components';
import KKPromo from "@/public/KinoklubbKnappEksternekinosider.svg";
import { toRem } from "lib/client/fonts";
import { useId } from "react";



//#region [Props]
type KinoklubbTicketProps = {
    className?: string;
};
//#endregion

//#region [Component]
export default function KinoklubbTicket({ className }: KinoklubbTicketProps) {
    return <Link href={process.env.NEXT_PUBLIC_KINOKLUBB_INFO_URL as string} passHref target="_blank" legacyBehavior>
        <SKinoklubbTicket className={className}>
            <SPromoDiv>
                <KKPromo role="img" alt="Se filmen til halv pris med Filmweb Kinoklubb. Klikk her for å lese mer og bli medlem."/>
            </SPromoDiv>
        </SKinoklubbTicket>
    </Link>;
}
//#endregion

//#region [Styles]
const SKinoklubbTicket = styled.a`
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #352761;
	background-color: #C8B886;
	text-align: center;
	padding: 0;
	font-size: ${toRem(11)};
`;

const SPromoDiv = styled.div`
    margin-top: .5em;
    padding: 5px;
    svg {
		display: block;
        margin: 0 auto;
        width: 100%;
	}
`;


//#endregion